module.exports = __webpack_public_path__ + "assets/media/greet.0942aa21.mp3";